import React from 'react';
import { OFFER_ANCHOR } from '../data/salesCopy';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  size?: 'md' | 'lg';
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  size = 'md',
  className = ''
}: CTAButtonProps) {
  const sizes = {
    md: 'px-5 py-3 text-[13px] sm:text-sm',
    lg: 'px-6 py-4 text-[14px] sm:text-base'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`inline-block w-full max-w-md rounded-md bg-brand-cta text-center font-sans font-bold uppercase tracking-wide text-white shadow-[0_6px_0_0_#42513F] transition-[transform,background-color] duration-150 ease-smooth hover:bg-brand-ctaDark active:translate-y-[3px] active:shadow-[0_3px_0_0_#42513F] ${sizes[size]} ${className}`} data-id="element-44" data-mp="2txjo2hzwo5cd">
      {children}
    </a>;
}